import React from "react";
import { useHistory } from "react-router";
import { useQuoteContext } from "../../../context-api/quote-context";
import { useNavContext } from "../../../context-api/nav-context";

const PostcodeForm = () => {
  const { closeNavbarMenu } = useNavContext();
  const { postcode, setPostcode } = useQuoteContext();
  const redirect = useHistory();

  const onChangeHandler = (e) => {
    const data = e.target.value;
    setPostcode(data);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    redirect.push("/prices");
  };
  return (
    <div className="form-card" onMouseOver={closeNavbarMenu}>
      <div className="form-card-info">
        <h3 className="question_subtitle">
          We use this to assign you an installation team (make sure you enter
          the right one, or you'll have to go back and change it later
        </h3>
      </div>
      <form className="postcode-form">
        <div className="form-controller">
          <input
            type="text"
            placeholder="eg LS16"
            value={postcode}
            onChange={onChangeHandler}
          />
        </div>
        <button
          type="submit"
          className="btn-hero btn-quote"
          onClick={submitHandler}
        >
          View Prices
        </button>
      </form>
    </div>
  );
};

export default PostcodeForm;
